import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'cboard.components.BoardShare.title',
    defaultMessage: 'Share your board'
  },
  close: {
    id: 'cboard.components.BoardShare.close',
    defaultMessage: 'Close'
  },
  unregisteredWarning: {
    id: 'cboard.components.BoardShare.unregisteredWarning',
    defaultMessage: 'You need to be registered to share a board!'
  },
  publishBoard: {
    id: 'cboard.components.BoardShare.publishBoard',
    defaultMessage: 'Publish Board'
  },
  unpublishBoard: {
    id: 'cboard.components.BoardShare.unpublishBoard',
    defaultMessage: 'Unpublish Board'
  },
  loginSignUp: {
    id: 'cboard.components.boardshare.loginSignUp',
    defaultMessage: 'Login or Sign up'
  },
  copyLink: {
    id: 'cboard.components.BoardShare.copyLink',
    defaultMessage: 'Copy Link'
  },
  facebook: {
    id: 'cboard.components.BoardShare.facebook',
    defaultMessage: 'Facebook'
  },
  twitter: {
    id: 'cboard.components.BoardShare.twitter',
    defaultMessage: 'Twitter'
  },
  email: {
    id: 'cboard.components.BoardShare.email',
    defaultMessage: 'Email'
  },
  whatsapp: {
    id: 'cboard.components.BoardShare.whatsapp',
    defaultMessage: 'Whatsapp'
  },
  reddit: {
    id: 'cboard.components.BoardShare.reddit',
    defaultMessage: 'Reddit'
  },
  subject: {
    id: 'cboard.components.BoardShare.subject',
    defaultMessage: 'Check out this board from Cboard!'
  },
  body: {
    id: 'cboard.components.BoardShare.body',
    defaultMessage:
      'Hello! I want to share a communication board from the Cboard tool. Please find it at: {url}'
  },
  cannotShare: {
    id: 'cboard.components.BoardShare.cannotShare',
    defaultMessage:
      'Cannot share the board on facebook. Please try again later.'
  }
});
